export default __webpack_public_path__ + "e3f069d1f238f98b1d8419e3d44e082d.svg";